<div class="new-claim-modal container">
    <div class="row">
      <div class="new-claim-modal__content new-claim-modal__content col-12">
        <div class="cx-dialog-header modal-header">
           
          <div class="cx-dialog-title modal-title">
           
          </div>
          <button
            type="button"
            class="close"
            aria-label="Close"
            cxModal="dismiss"
            cxModalReason="Cross click"
            (click)="closeModal()">
            <!-- <span aria-hidden="true">
              <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
              
            </span> -->
            <i class="fas fa-window-close"></i>
          </button>
        </div>
        <div class="cx-dialog-body modal-body">
         
            <div class="mb-2">
                <label>Unfortunately we are unable to proceed with your claim.</label>
                <label>Alternatively contact Customer Service on the below.</label>
            </div>
            <div class="mb-2">
                <small>Via telephone:</small>:<br>
                <label>1800 643 634 (within Australia)</label>
                <label>0800 643 634 (within New Zealand)</label>
            </div>
            <div class="mb-2">
                <small>Via email:</small>:<br>
                <label>customerservice.anz&#64;essity.com</label>           
            </div>
         
        </div>
       
      </div>
    </div>
  </div>
  